import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon'
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider'
import { useIntl } from 'react-intl'

const MuiLocalizationProviderWrapper = (props: React.PropsWithChildren<{}>) => {
  const intl = useIntl()
  return (
    <LocalizationProvider
      dateAdapter={AdapterLuxon}
      adapterLocale={intl.locale}
    >
      {props.children}
    </LocalizationProvider>
  )
}

export default MuiLocalizationProviderWrapper
